/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_Edit_TitleInputs */

const en_admin_permissions_edit_title = /** @type {(inputs: Admin_Permissions_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Permission`)
};

const zh_admin_permissions_edit_title = /** @type {(inputs: Admin_Permissions_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑权限`)
};

/**
* | output |
* | --- |
* | "Edit Permission" |
*
* @param {Admin_Permissions_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_permissions_edit_title = /** @type {((inputs?: Admin_Permissions_Edit_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_Edit_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_permissions_edit_title(inputs)
	return zh_admin_permissions_edit_title(inputs)
});
export { admin_permissions_edit_title as "admin.permissions.edit_title" }